import { ParameterType } from '@contracts';

export const DEFALUT_PARAMETER_DATA: ParameterType[] = [
  'kwh',
  'kw',
  'v_p1',
  'v_p2',
  'v_p3',
  'i_1',
  'i_2',
  'i_3',
];
